import { render, staticRenderFns } from "./BookingBreadcrumbEdit.vue?vue&type=template&id=055ffe3c&scoped=true&lang=html&"
import script from "./BookingBreadcrumbEdit.vue?vue&type=script&lang=js&"
export * from "./BookingBreadcrumbEdit.vue?vue&type=script&lang=js&"
import style0 from "./BookingBreadcrumbEdit.vue?vue&type=style&index=0&id=055ffe3c&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055ffe3c",
  null
  
)

export default component.exports